<script>
import axios from "axios";

import AforoExamenFisico from "../../components/Aforos/AforoExamenFisico.vue";
import SinAforo from "../../components/Aforos/SinAforo.vue";
import TitlePage from "../../components/layout/TitlePage.vue";
import Card from "../../components/ui/Card.vue";
import AforoArchivos from "../../components/Aforos/AforoArchivos.vue";
import ModalFormEditStatusAforo from "../../components/modals/ModalFormEditStatusAforo.vue";
import TIPO_INSPECCION from "../../constants/TiposInspeccion.js";

export default {
  components: {
    TitlePage,
    Card,
    AforoExamenFisico,
    SinAforo,
    AforoArchivos,
    ModalFormEditStatusAforo,
  },
  computed: {
    TIPO_INSPECCION() {
      return TIPO_INSPECCION;
    },
    sinAforo() {
      return this.aforo?.tipo_inspeccion?.id == TIPO_INSPECCION.SIN_AFORO;
    },
  },
  data() {
    return {
      aforoId: undefined,
      aforo: undefined,

      fetchIsPending: undefined,
      fetchIsSuccess: undefined,
      fetchIsError: undefined,

      showEditStatus: false,
    };
  },
  methods: {
    async fetchAforo() {
      this.fetchIsPending = true;

      try {
        const { data } = await axios.get(`/api/admin/aforos/${this.aforoId}`);

        if (data?.data) {
          this.aforo = { ...data.data };
        }
      } catch (e) {
        this.fetchIsError = true;
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al obtener los datos del despacho",
        });
      }

      this.fetchIsError = false;
      this.fetchIsSuccess = true;
      this.fetchIsPending = false;
    },
    async volverAforo() {
      this.$router.push({ name: "aforos" });
    },
  },
  mounted() {
    this.aforoId = this.$route?.params?.aforoId;
    this.fetchAforo();
  },
};

// TODO:  v-permisos="aforo.view"
</script>

<template>
  <div class="flex flex-col gap-12 w-full !text-left">
    <title-page title="Despachos" />

    <card
      title="Aforo de despacho"
      :segundoaccionBoton="volverAforo"
      :segundoboton="true"
      segundotext="Volver"
    >
      <div v-if="!fetchIsPending" class="flex flex-col gap-4">
        <div class="flex flex-row items-center gap-4 sm:justify-end">
          <button class="btn-principal" @click="() => (showEditStatus = true)">
            Cambiar estado
          </button>
        </div>

        <div class="flex flex-col gap-4">
          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Despacho</div>
            <div class="font-bold text-right">
              {{ aforo?.despacho?.despacho?.numero_despacho ?? "-" }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Tramitador aduanero</div>
            <div class="font-bold text-right">
              {{ aforo?.tramitador_aduanero?.name ?? "-" }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Cliente</div>
            <div class="font-bold text-right">
              {{ aforo?.despacho?.despacho?.cliente?.nombre ?? "-" }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Aduana</div>
            <div class="font-bold text-right">
              {{ aforo?.aduana?.nombre ?? "-" }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Fecha de Notificación</div>
            <div class="font-bold text-right">
              {{ sinAforo ? "-" : (aforo?.fecha_notificacion ?? "-") }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Código Agente</div>
            <div class="font-bold text-right">
              {{ aforo?.despacho?.despacho?.agente?.nombre ?? "-" }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Tipo Inspección</div>
            <div class="font-bold text-right uppercase">
              {{ aforo?.tipo_inspeccion?.nombre ?? "-" }}
            </div>
          </div>

          <div class="grid grid-cols-2 border-b border-primary/20">
            <div class="text-left">Estado</div>
            <div class="font-bold text-right uppercase">
              {{ aforo?.estado ?? "-" }}
            </div>
          </div>

          <aforo-examen-fisico
            v-if="aforo && aforo?.tipo_inspeccion?.id == TIPO_INSPECCION.FISICO"
            :data="aforo?.inspectable"
            :casillasVerificacion="aforo?.casillas"
          />

          <sin-aforo
            v-if="aforo && aforo?.tipo_inspeccion?.id == TIPO_INSPECCION.SIN_AFORO"
            :data="aforo?.inspectable"
          />

          <aforo-archivos v-if="aforo" :aforo="aforo" />
        </div>
      </div>

      <div v-else class="flex flex-row items-center p-4">
        <b-spinner
          class="text-primary mx-auto"
          style="width: 3em; height: 3em"
        />
      </div>
    </card>
    <modal-form-edit-status-aforo
      v-if="aforo"
      :visible="showEditStatus"
      :aforo="aforo"
      @close-modal="() => (showEditStatus = false)"
      @refetch="() => fetchAforo()"
    />
  </div>
</template>
